import * as React from 'react';
import { filter } from 'lodash';

import { DefaultButton } from '@magoosh/lib/button';
import { StudyScheduleData, StudyScheduleDetailData } from '../types';

interface Props {
  currentPlan?: StudyScheduleDetailData;
  onCancel: (any) => void;
  onOptOut: (any) => void;
  onComplete: (id: number) => void;
  plans: StudyScheduleData[];
}

export default ({ currentPlan, onCancel, onOptOut, onComplete, plans }: Props) => {
  const alternativePlans = filter(plans, (plan) => plan.id !== currentPlan?.id);

  return (
    <div>
      <h4 className="u-margin-V-n">
        <strong>Change Your Study Plan</strong>
      </h4>

      {currentPlan && (
        <div className="u-margin-T-m">You are currently using our {currentPlan.name} Plan.</div>
      )}
      <hr />

      <div className="u-margin-T-s">
        <p>
          {currentPlan ?
            'Not quite right? Choose from one of our other study plans below.' :
            'Choose from one of our study plans below.'}
        </p>
        {alternativePlans.map((plan) => (
          <DefaultButton block className="u-margin-V-s" data={plan.id} key={plan.id} onClick={onComplete}>
            {plan.name}
          </DefaultButton>
        ))}
        {currentPlan && (
          <DefaultButton block className="u-margin-V-s" onClick={onOptOut}>
            I'll study on my own instead
          </DefaultButton>
        )}
      </div>

      {window.location.toString().search('gmat') > -1 && (
        <p className="u-margin-T-m">GMAT Focus Edition Study Schedules coming soon!</p>
      )}

      <div className=" text-center u-margin-T-m">
        <a className="text-gray-light" onClick={onCancel}>
          Go Back
        </a>
      </div>
    </div>
  );
};
